var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3455 1.05284C1.75054 0.648757 2.40369 0.649054 2.80836 1.05373L8.02066 6.26602C8.36291 6.60828 8.36291 7.16172 8.02066 7.50397L2.80836 12.7163C2.40339 13.1212 1.74958 13.1212 1.34461 12.7163C0.939634 12.3113 0.939634 11.6575 1.34461 11.2525L5.70911 6.88199L1.33834 2.51121C0.939649 2.11252 0.939323 1.45175 1.3455 1.05284Z",
    fill: "#27374d",
    stroke: "#27374d",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.8e8f8521e9e9f260471b2799c86d79c0.svg";
export { ForwardRef as ReactComponent };